import { Box, Flex, Heading, Text } from '@radix-ui/themes'
import moment from 'moment'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { AiOutlineTrademarkCircle } from 'react-icons/ai'
import { PiCopyrightLight } from 'react-icons/pi'

import { Icon } from '#app/components/ui/icon.tsx'
import { ROOT_I18NEXT } from '#app/routes/_layout/route-config.ts'
import { testId } from '#app/utils/client/test-id.ts'

/* -------------------------------------------------------------------------------------------------
 * Copyright
 * -----------------------------------------------------------------------------------------------*/

enum TEST_ID {
	copyright = 'copyright',
}

const Copyright: React.FC = () => {
	const { t } = useTranslation(ROOT_I18NEXT.routeRoot)

	return (
		<Flex
			direction="column"
			align={{ initial: 'center', md: 'start' }}
			{...testId(TEST_ID.copyright)}
		>
			<Heading as="h2" weight="bold" size="4">
				<Flex align="center" gapX="1">
					<Text>{t('label.suwe')}</Text>
					<Box position="relative">
						<Box position="absolute" top="-.7rem" left="-.2rem">
							<Icon>
								<AiOutlineTrademarkCircle
									size=".6em"
									aria-label={t('label.registered_trademark')}
								/>
							</Icon>
						</Box>
					</Box>
					<Text>-</Text>
					<Text>{t('label.kosmetik')}</Text>
				</Flex>
			</Heading>
			<Flex
				asChild
				direction={{ initial: 'column', xs: 'row' }}
				gap="1"
				my="1"
				align="center"
			>
				<Text size="1" color="gray">
					<Flex align="center" gapX="1">
						<Text as="span" id="copyright">
							{t('label.copyright')}
						</Text>
						<Text>
							<PiCopyrightLight aria-labelledby="copyright" />
						</Text>
						<Text as="span">{moment().format('YYYY')}</Text>
					</Flex>
					<Flex align="center" gapX="1">
						<Text as="span">
							{t('label.suwe')}-{t('label.kosmetik')}.
						</Text>
						<Text as="span">{t('label.allRightsReserved')}.</Text>
					</Flex>
				</Text>
			</Flex>
		</Flex>
	)
}
Copyright.displayName = 'Copyright'

/* -----------------------------------------------------------------------------------------------*/

export { Copyright, TEST_ID as COPYRIGHT_TEST_ID }
